import React, { PureComponent } from 'react';
import { Add as AddIcon } from '@mui/icons-material';
import Text from '../../components/Text.js';
import TextInput from '../../components/TextFields/TextInput.js';
import Button from '../../components/Button.js';
import BubbleSelectBlock from '../../components/BubbleSelectBlock.js';
import Modal from '../../components/Modals/Modal.js';
import * as Services from '../../services/index.js';
import { globalStyles } from '../../theme/index.js';
import Loader from '../../components/Loader.js';
import EntityTable from './EntityTable.js';
import i18n from '../../localization/i18n.js';
import tokens from '../../localization/tokens.js';
class ClassesManagement extends PureComponent {
  state = {
    showNewUser: false,
    currentUser: '',
    selectedClass: 'all',
    selectedClassID: '',
    showNewClass: false,
    title: '',
    titleError: false,
    description: '',
    descriptionError: false,
    isRetiree: '',
    isClassEdit: false,
    showRemoveModal: false
  };
  _toggleAddClass = () => {
    this.setState({
      showNewClass: !this.state.showNewClass,
      title: '',
      description: '',
      isRetiree: false,
      isClassEdit: false
    });
  };
  _toggleRemoveClass = () => {
    this.setState({
      showRemoveModal: !this.state.showRemoveModal
    });
  };
  _validateClass = async () => {
    let titleError = await Services.validateInput('className', this.state.title);
    let descriptionError = await Services.validateInput('checkEmpty', this.state.description);
    if (this.state.title.length < 1) {
      titleError = i18n.t(tokens.labels.classesAndDivisions.classTitleRequired);
    } else if (this.state.title.length > 20) {
      titleError = i18n.t(tokens.labels.classesAndDivisions.classTitleLength);
    }
    if (this.state.description && this.state.description.length > 200) {
      descriptionError = i18n.t(tokens.labels.classesAndDivisions.descriptionLength);
    }
    this.setState({
      titleError,
      descriptionError
    });
    if (titleError || descriptionError) {
      return false;
    }
    return true;
  };
  _editClass = async () => {
    const isValid = await this._validateClass();
    if (!isValid) {
      return;
    }
    const success = await this.props.editClass(this.state.title.trim(), this.state.description.trim(), this.state.isRetiree, this.state.selectedClass, this.props.currentAccountMeta ? this.props.currentAccountMeta.accountID : null);
    if (success) {
      this.setState({
        titleError: false,
        descriptionError: false
      });
      this._toggleAddClass();
    }
  };
  _openEditClass = classData => {
    this.setState({
      showNewClass: true,
      title: classData.title.trim(),
      description: classData.description.trim(),
      isRetiree: classData.isRetiree,
      selectedClass: classData.classID,
      isClassEdit: true
    });
  };
  _openRemoveClass = classData => {
    this.setState({
      showRemoveModal: true,
      title: classData.title.trim(),
      description: classData.description.trim(),
      selectedClass: classData.classID
    });
  };
  _removeClass = async () => {
    const success = await this.props.removeClass(this.state.selectedClass);
    if (success) {
      this.setState({
        showRemoveModal: false,
        selectedClass: null
      });
    }
  };
  _addClass = async () => {
    const isValid = await this._validateClass();
    if (!isValid) {
      return;
    }
    const success = await this.props.addClass(this.state.title, this.state.description, this.state.isRetiree, this.props.currentAccountMeta ? this.props.currentAccountMeta.accountID : null);
    if (success) {
      this.setState({
        titleError: false,
        descriptionError: false
      });
      this._toggleAddClass();
      window.location.reload();
    }
  };
  _handleInputChange = (type, event) => {
    this.setState({
      [type]: event.target.value
    });
  };
  render() {
    const styles = {
      title: globalStyles.title,
      titleBlock: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: 10
      }
    };
    let canCreateClass = false;
    const isPrivateLabel = this.props.currentAccountMeta.isPrivateLabel;
    if (isPrivateLabel) {
      // classes can always be created for Private Label accounts
      canCreateClass = true;
    } else if (this.props.currentAccountMeta.status === 3 && this.props.step < 6 && this.props.isMasterSite) {
      // if the account is in revisions then only the master site can create classes
      canCreateClass = true;
    } else if (this.props.step <= 3 || (this.props.isMasterSite || isPrivateLabel) && this.props.step < 5) {
      canCreateClass = true;
    }
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      style: styles.titleBlock
    }, /*#__PURE__*/React.createElement(Text, {
      large: true,
      bold: true
    }, "Classes"), canCreateClass && /*#__PURE__*/React.createElement(Button, {
      transparent: true,
      onClick: this._toggleAddClass,
      customStyle: {
        marginLeft: 'auto'
      }
    }, /*#__PURE__*/React.createElement(AddIcon, {
      style: {
        fontSize: 17,
        lineHeight: '14px',
        color: 'inherit'
      }
    }), "\xA0", i18n.t(tokens.buttons.createClass))), /*#__PURE__*/React.createElement(EntityTable, {
      items: this.props.classData,
      edit: !(this.props.isMasterSite || isPrivateLabel) && this.props.step >= 4 ? null : this._openEditClass,
      remove: !this.props.isQuote ? null : !(this.props.isMasterSite || isPrivateLabel) && this.props.step >= 4 ? null : this._openRemoveClass,
      language: this.props.language || "en"
    }), /*#__PURE__*/React.createElement(Modal, {
      open: this.state.showRemoveModal,
      onClose: this._toggleRemoveClass,
      title: i18n.t(tokens.labels.classesAndDivisions.removeClass),
      primaryButton: {
        label: i18n.t(tokens.labels.classesAndDivisions.removeClass),
        onClick: this._removeClass
      },
      loader: this.props.loader
    }, /*#__PURE__*/React.createElement(Text, {
      medium: true,
      light: true
    }, i18n.t(tokens.labels.classesAndDivisions.removalConfirmation), " ", /*#__PURE__*/React.createElement("b", null, this.state.title), i18n.t(tokens.labels.classesAndDivisions.removalConfirmationData))), /*#__PURE__*/React.createElement(Modal, {
      open: this.state.showNewClass,
      onClose: this._toggleAddClass,
      title: this.state.isClassEdit ? i18n.t(tokens.titles.editClass) : i18n.t(tokens.titles.newClass),
      primaryButton: {
        onClick: this.state.isClassEdit ? this._editClass : this._addClass
      },
      loader: this.props.loader
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: i18n.t(tokens.labels.classesAndDivisions.title),
      value: this.state.title,
      onChange: value => this._handleInputChange('title', value),
      error: Boolean(this.state.titleError),
      helperText: this.state.titleError,
      fullWidth: true,
      autofocus: true
    }), /*#__PURE__*/React.createElement(TextInput, {
      label: i18n.t(tokens.labels.classesAndDivisions.description),
      value: this.state.description || '',
      onChange: value => this._handleInputChange('description', value),
      error: Boolean(this.state.descriptionError),
      helperText: this.state.descriptionError,
      fullWidth: true,
      autofocus: true
    }), this.props.isMasterSite && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
      medium: true,
      light: true,
      customStyle: {
        marginTop: "20px"
      }
    }, i18n.t(tokens.labels.classesAndDivisions.classRestrictionQuestion)), /*#__PURE__*/React.createElement(BubbleSelectBlock, {
      first: {
        title: i18n.t(tokens.buttons.yes),
        selected: this.state.isRetiree === true,
        field: 'isRetiree'
      },
      second: {
        title: i18n.t(tokens.buttons.no),
        selected: this.state.isRetiree === false,
        field: 'isRetiree'
      },
      handleChange: () => this.setState({
        isRetiree: !this.state.isRetiree
      })
    }))), /*#__PURE__*/React.createElement("span", {
      id: "classes-card"
    }));
  }
}
export default ClassesManagement;